module.exports = __webpack_public_path__ + "assets/c62ef6723eb7f5934e4306f60931f8ce.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/anticipate/L585MLA_SpinMelodyR4.mp3
 ** module id = 240
 ** module chunks = 0
 **/